import { render, staticRenderFns } from "./createCustomer.vue?vue&type=template&id=6894b1a2&"
import script from "./createCustomer.vue?vue&type=script&lang=js&"
export * from "./createCustomer.vue?vue&type=script&lang=js&"
import style0 from "./createCustomer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports